import {StepDataProvider} from 'components/common/CartItemBuilder/providers/StepDataProvider/StepDataProvider'
import {VentrataDataProvider} from 'components/common/CartItemBuilder/providers/VentrataDataProvider'
import {useCallback, useMemo} from 'react'
import {Ventrata} from 'types'
import {ga4} from 'utils/ga4'
import {Button} from './Button'

type Props = {
  unit: Ventrata.Unit
  isMaxNumberOfGuestsForOptionExeeded: boolean
  isMaxNumberOfGuestsForUnitExeeded: boolean
}

export const Counter = ({unit, isMaxNumberOfGuestsForOptionExeeded, isMaxNumberOfGuestsForUnitExeeded}: Props) => {
  const product = VentrataDataProvider.useProduct()
  const unitCounter = StepDataProvider.guests.useUnitCounter(unit.id)
  const setUnitCounter = StepDataProvider.guests.useUnitCounterSetter()

  const isPlusButtonDisabled = useMemo(() => {
    return isMaxNumberOfGuestsForUnitExeeded || isMaxNumberOfGuestsForOptionExeeded
  }, [isMaxNumberOfGuestsForUnitExeeded, isMaxNumberOfGuestsForOptionExeeded])

  const onCounterChange = useCallback(
    (newCounterValue: number) => {
      setUnitCounter(unit.id, newCounterValue)

      ga4({
        event: 'select_unit',
        label: unit.title,
        item_id: product.id,
        item_name: product.title,
        checkout_type: 'custom_checkout',
      })
    },
    [product, unit, setUnitCounter]
  )

  return (
    <div className="flex gap-2 items-center">
      <Button type="minus" disabled={unitCounter === 0} onClick={() => onCounterChange(unitCounter - 1)} />

      <div className="font-bold text-xl min-w-6 text-center">{unitCounter}</div>

      <Button type="plus" disabled={isPlusButtonDisabled} onClick={() => onCounterChange(unitCounter + 1)} />
    </div>
  )
}
